// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3rJ05","imageUploader":"EGiftCard_imageUploader__34bWa"};